/**
 * This file contains the URL routes that are appended to the project's sub-domain.
 * Use this file instead of {@type string} literals to maintain
 * a CGI (Common Gateway Interface) model for the application.
 *
 * {@link https://en.wikipedia.org/wiki/Common_Gateway_Interface}
 */

import {QUESTION_MARK} from "../utils/string";
import {TAB_LIVE_GPS, TAB_LIVE_VIEW, TAB_RECORDINGS} from "../components/unit/UnitTabSwitcher";
import {stringify} from "query-string";

export const WILDCARD = '*';
export const FORBIDDEN = '/403';
export const NOT_FOUND = '/404';
export const LANDING = 'http://theautoi.com/';
export const CONTACT_US = 'http://theautoi.com/contact-us/';
export const FORGOT_PASSWORD = '/ForgotPassword';
export const SIGN_UP = '/SignUp';
export const SIGN_IN = '/SignIn';
export const SIGN_OUT = "/SignOut";
export const HOME = '/';
export const ACCOUNT = '/AccountPage';
export const MESSAGES = '/Messages';

/** Parameterized unit queried routes */
export const UNIT = '/Unit';
export const UNIT_RECORDINGS_TAB = UNIT + QUESTION_MARK + stringify({tab:TAB_RECORDINGS});
export const UNIT_LIVE_GPS_TAB = UNIT + QUESTION_MARK + stringify({tab:TAB_LIVE_GPS});
export const UNIT_LIVE_VIEW_TAB = UNIT + QUESTION_MARK + stringify({tab:TAB_LIVE_VIEW});

/** Parameterized email queried routes */
export const EMAIL_SENT = 'EmailSent';
export const EMAIL_NOT_SENT = 'EmailNotSent';
export const NEW_USER = '/NewUserSignIn';
export const NEW_USER_SUCCESS = NEW_USER + '/:' + EMAIL_SENT;
export const NEW_USER_SUCCESS_EMAIL_SUCCESS = NEW_USER + '/' + EMAIL_SENT;
export const NEW_USER_SUCCESS_EMAIL_FAILURE = NEW_USER + '/' + EMAIL_NOT_SENT;
export const PASSWORD_RESET = '/PasswordReset';
export const PASSWORD_RESET_SUCCESS = PASSWORD_RESET + '/:' + EMAIL_SENT;
export const PASSWORD_RESET_SUCCESS_EMAIL_SUCCESS = PASSWORD_RESET + '/' + EMAIL_SENT;
export const PASSWORD_RESET_SUCCESS_EMAIL_FAILURE = PASSWORD_RESET + '/' + EMAIL_NOT_SENT;

/** Parameterized recording query routes */
export const RECORDING = '/Recording';
export const ENCODED_QUERY_STRING = 'encodedRecordingQueryString';
export const RECORDING_UNIT_SHORTHAND = 'u';
export const RECORDING_ID_SHORTHAND = 'id';
export const RECORDING_QUERY = RECORDING + '/:' + ENCODED_QUERY_STRING;



// WEBPACK FOOTER //
// ./src/constants/routes.js